module.exports = __webpack_public_path__ + "img/home_vip_pop_limited_time_ko.e000d530.png";